import { compose } from 'recompose';
import { connect } from 'react-redux';

import {
  sendingSelector,
  succeedSelector,
  usersSelector,
} from '../../../redux/board/selectors/AllUsers';
import { actions as reqAllUsers } from '../../../redux/board/reqAllUsers';

const mapStateToProps = state => ({
  users: usersSelector(state),
  loading: sendingSelector(state),
  succeed: succeedSelector(state),
});

const mapDispatchToProps = {
  getUsers: reqAllUsers.send,
  clear: reqAllUsers.clear,
  clearStatus: reqAllUsers.clearStatus,
};

export const enhance = compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
);



// WEBPACK FOOTER //
// ./src/components/common/SearchDialog/enhance.js